import Main from './Components/MainComponent'

function App() {
  return (
    <Main />
  );
}

export default App;
